const GC = () => {
  return (
    <div className="h-full w-full overflow-y-auto bg-gray-50 p-6 custom-scrollbar">
      <main className="max-w-5xl mx-auto bg-white rounded-2xl shadow-lg prose prose-lg p-8 md:p-12">
        <header className="flex flex-col md:flex-row items-start justify-between gap-6 border-b border-gray-100 pb-8 mb-8">
          <div>
            <h1 className="text-3xl font-extrabold text-gray-900 leading-tight m-0">
              CONDITIONS GÉNÉRALES RESTAURATEURS PARTENAIRES - BIPBIP42.FR
            </h1>
            <p className="text-base text-gray-500 mt-2 font-medium">
              Accord de partenariat entre le Restaurant Partenaire et BIP BIP
            </p>
          </div>
        </header>

        <nav className="mb-12 p-6 bg-gray-50 rounded-xl border border-gray-100 print:hidden">
          <h2 className="text-xl font-bold text-gray-800 mb-4 mt-0">
            Sommaire
          </h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2 list-none p-0 m-0">
            <li>
              <a
                href="#intro"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                Introduction
              </a>
            </li>
            <li>
              <a
                href="#definitions"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                1. Définitions
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                2. Services fournis par BIP BIP
              </a>
            </li>
            <li>
              <a
                href="#mise-en-ligne"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                3. Mise en ligne des informations
              </a>
            </li>
            <li>
              <a
                href="#commandes"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                4. Commandes et contrats
              </a>
            </li>
            <li>
              <a
                href="#declarations"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                5. Déclarations et garanties
              </a>
            </li>
            <li>
              <a
                href="#obligations"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                6. Obligations du Restaurant Partenaire
              </a>
            </li>
            <li>
              <a
                href="#commission"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                7. Commission / Frais de livraison
              </a>
            </li>
            <li>
              <a
                href="#paiement"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                8. Paiement
              </a>
            </li>
            <li>
              <a
                href="#responsabilite"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                9. Responsabilité
              </a>
            </li>
            <li>
              <a
                href="#assurance"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                10. Assurance
              </a>
            </li>
            <li>
              <a
                href="#ip"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                11. Propriété intellectuelle
              </a>
            </li>
            <li>
              <a
                href="#donnees"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                12. Données personnelles
              </a>
            </li>
            <li>
              <a
                href="#resiliation"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                13. Résiliation
              </a>
            </li>
            <li>
              <a
                href="#cession"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                14. Cession
              </a>
            </li>
            <li>
              <a
                href="#force-majeure"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                15. Force majeure
              </a>
            </li>
            <li>
              <a
                href="#confidentialite"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                16. Confidentialité
              </a>
            </li>
            <li>
              <a
                href="#independance"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                17. Indépendance des parties
              </a>
            </li>
            <li>
              <a
                href="#diverses"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                18. Dispositions diverses
              </a>
            </li>
            <li>
              <a
                href="#loi"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                19. Loi applicable
              </a>
            </li>
            <li>
              <a
                href="#competence"
                className="text-primary hover:text-red-700 hover:underline transition-colors block py-1"
              >
                20. Attribution de compétence
              </a>
            </li>
          </ul>
        </nav>

        <section
          id="intro"
          className="mb-10 scroll-mt-24"
        >
          <p>
            Les présentes conditions générales restaurateurs partenaires BIP BIP
            (les “Conditions Générales”) sont applicables à tout Restaurant
            Partenaire ayant conclu un accord de partenariat avec BIP BIP en vue
            d’être référencé sur la Plateforme BIP BIP.
          </p>
          <p>
            Les Conditions Générales complètent et forment un tout indissociable
            avec l’Accord conclu entre le Restaurant Partenaire et BIP BIP.
          </p>
          <p>
            L’application d’autres conditions générales, telles que celles du
            Restaurant Partenaire, est exclue.
          </p>
          <p>
            BIP BIP se réserve la possibilité de modifier les Conditions
            Générales à tout moment en communiquant au préalable le projet de
            version modifiée des Conditions Générales aux Restaurants
            Partenaires. À défaut d’opposition expresse à la nouvelle version
            des Conditions Générales passé un délai de sept (7) jours
            calendaires, les Conditions Générales modifiées seront mises en
            ligne et seront réputées en vigueur. À compter de leur mise en
            ligne, les Conditions Générales modifiées remplacent les anciennes
            Conditions Générales
          </p>
          <p>
            Les Conditions Générales en vigueur sont disponibles en ligne à
            l’adresse suivante : Site Internet
          </p>
        </section>

        <section
          id="definitions"
          className="mb-10 scroll-mt-24"
        >
          <h2>1. DÉFINITIONS</h2>
          <dl className="grid gap-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">“Accord”</dt>
              <dd className="mt-1">
                L’accord de partenariat conclu entre le Restaurant Partenaire et
                BIP BIP.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">“Contrat”</dt>
              <dd className="mt-1">
                Contrat entre un Client et un Restaurant Partenaire formé lors
                de la passation d’une Commande pour la livraison de repas, de
                boissons et/ou de produits associés par le Client auprès du
                Restaurant Partenaire par l’intermédiaire de la Plateforme.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">“Client”</dt>
              <dd className="mt-1">
                Personne qui effectue une Commande auprès du Restaurant
                Partenaire par l’intermédiaire de la Plateforme.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">“Commande”</dt>
              <dd className="mt-1">
                Une commande effectuée par un Client auprès du Restaurant
                Partenaire par l’intermédiaire de la Plateforme.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">“Commission”</dt>
              <dd className="mt-1">
                La commission due par le Restaurant Partenaire à BIP BIP en
                contrepartie des Services dont le montant est défini dans
                l’Accord. La Commission est appliquée sur le prix de chaque
                produit vendu par le Restaurant Partenaire par l’intermédiaire
                de la Plateforme.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">
                “Données Personnelles”
              </dt>
              <dd className="mt-1">
                Tout type de données (i) concernant une personne physique
                identifiée ou identifiable et/ou (ii) qui peuvent
                raisonnablement être utilisées pour identifier ou authentifier
                un individu, y compris, sans toutefois s’y limiter, le nom, les
                coordonnées de contact, les informations précises de
                localisation et les identificateurs permanents, et/ou (iii) qui
                pourraient autrement être considérées comme “données
                personnelles” ou “information à caractère personnel” en vertu de
                la loi en vigueur, qui sont confiées au Restaurant Partenaire
                par BIP BIP.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">“Frais de livraison”</dt>
              <dd className="mt-1">
                Le coût de la prestation du Livreur pour la livraison d’une
                Commande à un Client.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">
                “Informations Confidentielles”
              </dt>
              <dd className="mt-1">
                Toutes informations ou toutes données communiquées par une
                Partie (“Partie Émettrice”) à l’autre Partie (“Partie
                Récipiendaire”), de quelque nature que ce soit, par écrit ou
                oralement, préalablement ou postérieurement à la signature de
                l’Accord.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">
                “Informations sur le Restaurant Partenaire”
              </dt>
              <dd className="mt-1">
                Toutes informations pertinentes concernant le Restaurant
                Partenaire. Les Informations sur le Restaurant Partenaire
                concernent entre autres :
                <ul className="list-disc ml-5 mt-2 space-y-1">
                  <li>
                    Les informations et les coordonnées du Restaurant
                    Partenaires
                  </li>
                  <li>
                    La gamme des produits (entrées, plats, desserts, boissons,
                    accompagnements, options et autres produits de restauration
                    associés, ingrédients et quantité si requis)
                  </li>
                  <li>Les menus</li>
                  <li>
                    Les prix pour chaque produit individuel (TVA comprise)
                  </li>
                  <li>Le logo</li>
                  <li>La marque</li>
                  <li>La zone de livraison (code postaux)</li>
                  <li>Les quantités minimales à commander</li>
                  <li>Les quantités disponibles de chaque produit</li>
                  <li>Les heures d’ouverture</li>
                </ul>
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">“Livreur”</dt>
              <dd className="mt-1">
                Prestataire indépendant qui propose des services de transport et
                livraison.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">“Marques”</dt>
              <dd className="mt-1">
                Les marques de commerce, marques de service, noms, appellations
                et dénominations commerciales, droits d’auteur, logos, slogans
                et autres symboles et signes caractéristiques d’identification
                d’une partie.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">
                “Montant de la Commande”
              </dt>
              <dd className="mt-1">
                Le prix total (TVA comprise) de l’ensemble des produits figurant
                dans la Commande d’un Client, hors Frais de Livraison.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">“Partie(s)”</dt>
              <dd className="mt-1">BIP BIP et/ou le Restaurant Partenaire</dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">“Plateforme”</dt>
              <dd className="mt-1">
                Le site internet, l’application et les outils/équipement de BIP
                BIP sur lesquels les Services sont proposés.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">“Réclamation”</dt>
              <dd className="mt-1">
                Réclamation ou plainte d’un Client fondée sur une non-conformité
                d’un ou plusieurs produits livrés avec la Commande effectuée.
                Une non-conformité est notamment établie dans les cas suivants,
                sans limitation :
                <ul className="list-disc ml-5 mt-2 space-y-1">
                  <li>
                    Produit livré ne correspondant pas au produit commandé
                  </li>
                  <li>Produit manquant</li>
                  <li>Produit abîmé</li>
                  <li>Produit insatisfaisant</li>
                  <li>
                    Produit mal conditionné (conditionnement non adapté, sûr ou
                    hygiénique).
                  </li>
                </ul>
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">“Réglementation RGPD”</dt>
              <dd className="mt-1">
                La Loi n°78-17 du 06 janvier 1978 relative à l’informatique, aux
                fichiers et aux libertés, mise à jour par la Loi n° 2018-493 du
                20 juin 2018 et le Règlement (UE) 2016/679 du Parlement européen
                et du Conseil du 27 avril 2016 sur la protection des personnes
                physiques en ce qui concerne le traitement des données à
                caractère personnel et la libre circulation de ces données.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">
                “Restaurant Partenaire”
              </dt>
              <dd className="mt-1">
                Toute société de restauration qui prépare des repas, des
                boissons et des produits associés et qui a conclu un accord de
                partenariat avec BIP BIP.
              </dd>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <dt className="font-bold text-gray-900">“Service”</dt>
              <dd className="mt-1">
                Services exécutés par BIP BIP tels que décrits dans les
                présentes Conditions Générales et qui sont composés des :
                <ul className="list-disc ml-5 mt-2 space-y-1">
                  <li>(i) Services d’accès à la Plateforme</li>
                  <li>(ii) Services de mise en relation pour la livraison</li>
                  <li>(iii) Service de collecte paiement</li>
                  <li>(iv) Service de remontée d’informations</li>
                  <li>(v) Services additionnels facultatifs</li>
                </ul>
              </dd>
            </div>
          </dl>
        </section>

        <section
          id="services"
          className="mb-10 scroll-mt-24"
        >
          <h2>2. SERVICES FOURNIS PAR BIP BIP</h2>
          <p>
            BIP BIP fournit les Services suivants au Restaurant Partenaire :
          </p>

          <h3 className="font-bold mt-6 mb-2">
            2.1. Services d’accès à la Plateforme
          </h3>
          <p>
            BIP BIP met à la disposition du Restaurant Partenaire sa Plateforme
            afin de mettre en relation le Restaurant Partenaire avec des
            Clients. Le rôle de BIP BIP est celui d’intermédiaire pour le compte
            du Restaurant Partenaire.
          </p>

          <h3 className="font-bold mt-6 mb-2">
            2.2. Services de mise en relation pour la livraison
          </h3>
          <p>
            BIP BIP met le Restaurant Partenaire en relation avec des Livreurs
            pour la livraison des plats et/ou boissons commandés par les Clients
            via la Plateforme. BIP BIP agit en qualité de simple intermédiaire
            entre le Restaurant Partenaire et le Livreur.
          </p>

          <h3 className="font-bold mt-6 mb-2">
            2.3. Services de collecte de paiement
          </h3>
          <p>
            BIP BIP met en place un service de collecte de paiement pour le
            compte du Restaurant Partenaire. À ce titre, BIP BIP agit en qualité
            de collecte des paiements réalisés par les Clients pour les
            commandes passées par l’intermédiaire de la Plateforme auprès du
            Restaurant Partenaire.
          </p>

          <h3 className="font-bold mt-6 mb-2">
            2.4. Services de remontée d’information
          </h3>
          <p>
            BIP BIP fournit au Restaurant Partenaire des informations concernant
            :
          </p>
          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li>
              le nombre de produits vendus via la Plateforme et qui sont
              récupérés par les Livreurs
            </li>
            <li>
              le montant et la date des remboursements versés aux Clients au
              titre des Réclamations.
            </li>
          </ul>

          <h3 className="font-bold mt-6 mb-2">
            2.5. Services additionnels facultatifs
          </h3>
          <p>
            BIP BIP propose au Restaurant Partenaire la mise à disposition
            d’outils informatiques (software et/ou hardware - ex : tablette)
            pour la mise à jour des Informations sur le Restaurant Partenaire et
            la prise de Commandes. Ce service est facultatif.
          </p>
          <div className="bg-blue-50 p-4 rounded-lg mt-4 border border-blue-100">
            <p className="font-semibold text-blue-900 mb-2">
              Modalités de mise à disposition d’une tablette ou abonnement :
            </p>
            <ul className="list-disc ml-5 text-blue-800">
              <li>
                Coût : Abonnement disponible sur votre propre support à 49€ HT
                par année prélevé sur votre compte en banque
              </li>
              <li>
                Et/ou achat direct d’une tablette d’un montant de 220€ H.T. au
                moment de la signature du partenariat.
              </li>
            </ul>
          </div>
        </section>

        <section
          id="mise-en-ligne"
          className="mb-10 scroll-mt-24"
        >
          <h2>
            3. MISE EN LIGNE DES INFORMATIONS SUR LE RESTAURANT PARTENAIRE SUR
            LA PLATEFORME
          </h2>

          <h3 className="font-bold mt-6 mb-2">
            3.1. Exactitude des Informations sur le Restaurant Partenaire
          </h3>
          <p>
            Afin que les Clients puissent passer commande auprès du Restaurant
            Partenaire par l&apos;intermédiaire de la Plateforme, BIP BIP publie
            sur la Plateforme les Informations sur le Restaurant Partenaire
            communiquées par ce dernier qui sont utiles et pertinentes pour la
            passation des commandes.
          </p>
          <p>
            En conséquence, le Restaurant Partenaire a la responsabilité de
            fournir à BIP BIP des Informations sur le Restaurant Partenaire
            exactes et complètes. Il appartient également au Restaurant
            Partenaire d’informer BIP BIP dans les plus brefs délais de tout
            changement dans les Informations sur le Restaurant Partenaire.
          </p>
          <p>
            En cas de Réclamation d’un Client en raison d’une erreur dans les
            Informations sur le Restaurant Partenaire transmise par le
            Restaurant Partenaire, BIP BIP se réserve le droit de déduire du
            Montant de la Commande le prix du(es) produit(s) dans les conditions
            définies à l’article 8.
          </p>

          <h3 className="font-bold mt-6 mb-2">3.2. Prix des produits</h3>
          <p>
            Le Restaurant Partenaire définit librement et communique à BIP BIP
            le prix de vente (H.T. et T.T.C.) de chaque produit proposé à la
            vente sur la Plateforme dans la limite maximum de +20% du prix de
            vente de ce même produit pratiqué par le Restaurant Partenaire en
            cas d’achat du produit sur place.
          </p>
          <p>
            Le Restaurant Partenaire est seul responsable de la détermination
            des taxes applicables aux produits proposés à la vente sur la
            Plateforme. Le Restaurant Partenaire est également seul responsable
            de la collecte et du versement des taxes applicables, notamment la
            TVA, sur les produits vendus via la Plateforme.
          </p>

          <h3 className="font-bold mt-6 mb-2">
            3.3. Horaires d’ouverture (responsabilité du Restaurant Partenaire)
          </h3>
          <p>
            Le Restaurant Partenaire définit librement ses horaires d’ouverture
            dans les limites éventuelles imposées par BIP BIP.
          </p>
          <p>
            Le Restaurant Partenaire a la responsabilité d’indiquer lui-même sur
            la Plateforme tout changement dans ses horaires d’ouverture (ex :
            fermeture exceptionnelle un jour donné, fermeture continue pendant
            une période, etc.).
          </p>
          <p>
            À défaut de mise à jour de ses horaires d’ouverture par le
            Restaurant Partenaire entraînant une obligation pour BIP BIP
            d’annuler des Commandes ne pouvant être honorées et de rembourser
            les Clients, BIP BIP se réserve la faculté de facturer des pénalités
            au Restaurant Partenaire. En cas de manquement répété, BIP BIP
            pourra résilier l’Accord pour faute.
          </p>

          <h3 className="font-bold mt-6 mb-2">
            3.4. Quantités disponibles (responsabilité du Restaurant Partenaire)
          </h3>
          <p>
            Le Restaurant Partenaire détermine librement les quantités
            disponibles de chaque produit/menu.
          </p>
          <p>
            Le Restaurant Partenaire a la responsabilité d’indiquer lui-même sur
            la Plateforme les quantités disponibles.
          </p>
          <p>
            À défaut de mise à jour des quantités disponibles entraînant une
            obligation pour BIP BIP d’annuler des Commandes ne pouvant être
            honorées et de rembourser les Clients, BIP BIP se réserve la faculté
            de facturer des pénalités au Restaurant Partenaire. En cas de
            manquement répété, BIP BIP pourra résilier l’Accord pour faute.
          </p>
        </section>

        <section
          id="commandes"
          className="mb-10 scroll-mt-24"
        >
          <h2>4. COMMANDES ET CONTRATS</h2>

          <h3 className="font-bold mt-6 mb-2">4.1. Passation des Commandes</h3>
          <p>
            Les Clients peuvent effectuer une Commande auprès du Restaurant
            Partenaire par l’intermédiaire de la Plateforme sur la base des
            Informations sur le Restaurant Partenaire fournies par le Restaurant
            Partenaire à BIP BIP.
          </p>

          <h3 className="font-bold mt-6 mb-2">4.2. Conclusion des Contrats</h3>
          <p>
            Un Contrat est conclu entre le Client et le Restaurant Partenaire au
            moment où un Client effectue une Commande auprès du Restaurant
            Partenaire par l’intermédiaire de la Plateforme.
          </p>
          <p>
            A réception d’une Commande, le Restaurant Partenaire a la faculté de
            :
          </p>
          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li>traiter la Commande tout de suite</li>
            <li>reporter le traitement de la Commande à plus tard.</li>
          </ul>
          <p>
            À défaut de choix, le traitement de la Commande est automatiquement
            considéré comme reporté à plus tard.
          </p>
          <p>
            En cas de report du traitement de la Commande à plus tard, le
            Restaurant Partenaire s’engage à exécuter la Commande dans un délai
            maximum de [45 minutes] à compter de la réception de la Commande.
          </p>

          <h3 className="font-bold mt-6 mb-2">
            4.3. Préparation de la Commande et exécution du Contrat
          </h3>
          <p>
            Dès la réception de la commande, le Restaurant Partenaire s’engage à
            préparer la Commande en vue de sa livraison au Client dans le
            respect des obligations définies ci-dessous et dans le reste des
            présentes Conditions Générales :
          </p>
          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li>
              <span className="font-semibold">Température :</span> Les produits
              chauds commandés doivent être remis en livraison à une température
              qui ne doit pas être inférieure à 63 °C et les produits froids
              commandés doivent être remis en livraison à une température qui ne
              doit pas être inférieure à 2 °C (les « Limites de température de
              sécurité »)
            </li>
            <li>
              <span className="font-semibold">Quantités :</span> le Restaurant
              détermine librement les quantités, portion, taille des produits
              proposés à la vente sur la Plateforme dans la limite, pour chaque
              produit, de ce qui est raisonnablement attendu pour un produit
              similaire dans un établissement de restauration de même standing
              (les « Normes standards »).
            </li>
          </ul>

          <p>
            Dans l&apos;hypothèse où un Restaurant Partenaire ne respecterait
            pas les Limites de température de sécurité et/ou les Normes
            standards, BIP BIP se réserve le droit de retirer le(s) produit(s)
            concerné(s) de la Plateforme. En cas de manquement répété à ces
            obligations, BIP BIP peut librement décider de déréférencer le
            Restaurant Partenaire de la Plateforme. Ces sanctions sont sans
            préjudice du droit de BIP BIP de déduire du Montant de la Commande
            le prix du(es) produit(s) en cas de Réclamation fondée sur un
            non-respect des Limites de température de sécurité et/ou les Normes
            standards dans les conditions définies à l’article 8.
          </p>

          <p>
            Le Restaurant Partenaire est seul responsable de la conformité du
            Contrat à la Commande et de l’exécution du Contrat avec le Client.
            BIP BIP ne constitue pas une partie au contrat entre le Restaurant
            Partenaire et le Client. BIP BIP agit en simple qualité
            d’intermédiaire entre le Restaurant Partenaire et le Client.
          </p>

          <h3 className="font-bold mt-6 mb-2">
            4.4. Conditionnement de la Commande
          </h3>
          <p>
            Le Restaurant Partenaire est responsable des produits commandés
            jusqu’à leur livraison au Client. Il appartient en conséquence au
            Restaurant Partenaire de choisir un conditionnement adapté, sûr et
            hygiénique permettant la sauvegarde des produits vendus dans un état
            acceptable jusqu’à leur livraison au Client en vue de leur
            consommation par le Client.
          </p>
          <p>
            Il est rappelé que les Livreurs sont des prestataires indépendants
            et, en tant que tels, ils se réservent le droit de refuser de
            transporter tout élément à leur seule discrétion. Dans tous les cas,
            les Commandes remises aux Livreurs ne doivent pas dépasser un poids
            (total) supérieur à 15 kg.
          </p>
          <p>
            BIP BIP transmettra aux Livreurs toute directive raisonnable fournie
            par le Restaurant Partenaire concernant la livraison des Commandes.
          </p>
        </section>

        <section
          id="declarations"
          className="mb-10 scroll-mt-24"
        >
          <h2>5. DÉCLARATIONS ET GARANTIES</h2>
          <h3 className="font-bold mt-6 mb-2">
            5.1. Déclarations et garanties réciproques
          </h3>
          <p>
            Chaque Partie déclare et garantit à l’autre Partie ce qui suit :
          </p>
          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li>
              elle détient les pleins pouvoirs et l&apos;autorité de conclure
              l’Accord et de s’acquitter des obligations stipulées dans les
              présentes
            </li>
            <li>
              elle est dûment constituée, valablement existante et en règle au
              regard de la législation applicable
            </li>
            <li>
              elle n’a conclu aucun contrat susceptible de l’empêcher de
              respecter l’Accord et les Conditions Générales et s’abstiendra de
              le faire pendant la durée d’exécution de l’Accord
            </li>
            <li>
              elle respectera l’ensemble des lois et des réglementations
              applicables dans le cadre de l’exécution de l’Accord
            </li>
            <li>
              les éléments utilisés ou fournis dans le cadre de l’Accord ne
              porteront pas atteinte ni n’enfreindront les droits de propriété
              intellectuelle ou les autres droits patrimoniaux d’un tiers.
            </li>
          </ul>
          <h3 className="font-bold mt-6 mb-2">
            5.2. Déclarations et garanties du Restaurant Partenaire
          </h3>
          <p>Le Restaurant Partenaire garantit à BIP BIP à tout moment que :</p>
          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li>
              il est en conformité avec toutes les lois et réglementations
              applicables, notamment pour les questions de sécurité alimentaire
              et d’hygiène
            </li>
            <li>
              les plats, boissons et autres produits associés qui sont proposés
              sur la Plateforme conviennent à la consommation et répondent aux
              normes de la législation alimentaire en vigueur et à tout autre
              législation et réglementation applicable
            </li>
            <li>
              il dispose de toutes les licences requises pour gérer le
              Restaurant Partenaire et exécuter les obligations de chaque
              Contrat
            </li>
            <li>
              il n’est pas faillite, ni insolvable et ne fait pas l’objet d’une
              procédure de sauvegarde, de redressement ou de liquidation
              judiciaire
            </li>
            <li>
              les informations sur le Restaurant peuvent être librement
              utilisées et traitées par BIP BIP et mises en lignes sur la
              Plateforme.
            </li>
          </ul>
        </section>

        <section
          id="obligations"
          className="mb-10 scroll-mt-24"
        >
          <h2>6. OBLIGATIONS DU RESTAURANT PARTENAIRE</h2>
          <p className="mb-2">Le Restaurant Partenaire s’engage à :</p>
          <ul className="list-disc ml-5 space-y-1">
            <li>
              <span className="font-semibold">6.1.</span> collaborer avec BIP
              BIP afin de faciliter la réalisation des Services
            </li>
            <li>
              <span className="font-semibold">6.2.</span> fournir de manière
              exhaustive et complète les Informations sur le Restaurant
              Partenaire à BIP BIP et à communiquer à BIP BIP sans délai tout
              changement dans les Informations sur le Restaurant Partenaire
            </li>
            <li>
              <span className="font-semibold">6.3.</span> fournir à BIP BIP
              toute information additionnelle portant sur le Restaurant
              Partenaire ou sur les produits du Restaurant à première demande de
              BIP BIP
            </li>
            <li>
              <span className="font-semibold">6.4.</span> assurer la
              disponibilité générale de ses produits et menus et à assurer la
              préparation des Commandes dans des délais convenables pendant ses
              heures d’ouverture
            </li>
            <li>
              <span className="font-semibold">6.5.</span> ne pas utiliser la
              Plateforme pour la vente de produits dont la vente est considérée
              illégale
            </li>
            <li>
              <span className="font-semibold">6.6.</span> ne pas remettre à la
              livraison tout animal, objet fragile, objet dangereux (tel que des
              6 armes, des explosifs, des éléments inflammables, etc.), objet
              volé ou tout autre objet jugé illicite
            </li>
            <li>
              <span className="font-semibold">6.7.</span> informer BIP BIP dans
              les meilleurs délais de toute inspection alimentaire menée par une
              autorité compétente dans le Restaurant Partenaire et du résultat
              de cette inspection.
            </li>
          </ul>
        </section>

        <section
          id="commission"
          className="mb-10 scroll-mt-24"
        >
          <h2>7. COMMISSION BIP BIP / FRAIS DE LIVRAISON</h2>
          <h3 className="font-bold mt-6 mb-2">7.1. Commission BipBip</h3>
          <p>
            En contrepartie des Services fournis par BIP BIP au Restaurant
            Partenaire, le Restaurant Partenaire est redevable de la Commission
          </p>
          <p>
            La Commission est prélevée par BIP BIP de manière automatique sur
            chaque Commande, ce que le Restaurant Partenaire reconnaît et
            accepte
          </p>

          <h3 className="font-bold mt-6 mb-2">7.2. Frais de livraison</h3>
          <p>
            Pour chaque Commande, BIP BIP collecte, pour le compte du Restaurant
            Partenaire, les Frais de Livraison auprès du Client ayant effectué
            la Commande. Les Frais de Livraison sont facturés en supplément du
            Montant de la Commande, c’est-à-dire en supplément du prix de vente
            pour la totalité des produits composant la Commande.
          </p>
          <p>
            Les Frais de Livraison sont calculés sur la base de la distance
            parcourue pour chaque Commande et du temps consacré par le Livreur à
            la livraison de la Commande.
          </p>
          <p>
            Le Restaurant Partenaire autorise BIP BIP à reverser les Frais de
            Livraison collectés en totalité au Livreur à la fin de la livraison.
          </p>
          <p>
            En étant référencé sur la Plateforme, le Restaurant Partenaire
            accepte le principale de la collecte des Frais de Livraison par BIP
            BIP et leur reversement aux Livreurs.
          </p>
        </section>

        <section
          id="paiement"
          className="mb-10 scroll-mt-24"
        >
          <h2>8. PAIEMENT DU RESTAURANT PARTENAIRE</h2>
          <p>
            BIP BIP s’engage à reverser au Restaurant Partenaire le Montant de
            la Commande collecté auprès du Client après déduction du montant (i)
            de la Commission et (ii) des éventuelles Réclamations et (iii) des
            éventuelles pénalités dans le délai suivant :
          </p>
          <p className="ml-5 mt-2 bg-yellow-50 p-2 rounded border border-yellow-200 text-yellow-800 font-medium">
            - Fin de semaine suivant la date de paiement du Montant de la
            Commande augmenté de sept (7) jours
          </p>
          <p>
            Les paiements effectués par BIP BIP seront effectués par virement en
            Euros sur le compte bancaire du Restaurant Partenaire dont les
            coordonnées auront été préalablement communiquées à BIP BIP.
          </p>
        </section>

        <section
          id="responsabilite"
          className="mb-10 scroll-mt-24"
        >
          <h2>9. RESPONSABILITÉ</h2>
          <h3 className="font-bold mt-6 mb-2">9.1. Règles générales</h3>
          <p>
            Chacune des Parties garantit la bonne exécution de ses obligations,
            et s&apos;engage à remédier, sans retard et à ses frais, à tout
            défaut d&apos;exécution desdites obligations.
          </p>
          <p>
            Chaque partie (la « Partie Indemnisatrice ») indemnisera, défendra
            et dégagera de toute responsabilité l&apos;autre Partie (la « Partie
            indemnisée ») concernant l’ensemble des réclamations, dommages,
            pertes et préjudices (y compris les honoraires d’avocat et de
            conseil) liés à toute réclamation de tiers découlant ou se
            rapportant à :
          </p>
          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li>
              a) une violation des obligations, engagements, déclarations et
              garanties prévus dans l’Accord
            </li>
            <li>
              b) la négligence ou la faute délibérée de la Partie Indemnisatrice
              et de ses employés ou agents dans l&apos;exécution de l’Accord
            </li>
            <li>
              c) un usage des Marques contraire ou violant le droit de propriété
              intellectuelle de tiers
            </li>
            <li>
              d) un manquement ou une violation de la législation applicable,
              notamment toute réglementation sur la santé et la sécurité.
            </li>
          </ul>
          <p>
            En toute hypothèse, la responsabilité de BIP BIP ne saurait être
            engagée, sur quelque fondement que ce soit, au titre de toute perte
            d’activité, perte de chiffre d’affaires, perte de résultat et/ou
            perte de chance
          </p>

          <h3 className="font-bold mt-6 mb-2">
            9.2. Responsabilité propre du Restaurant Partenaire
          </h3>
          <p className="font-semibold underline">
            Horaires d’ouverture et disponibilité des produits
          </p>
          <p>
            Conformément aux articles 3.3 et 3.4, le Restaurant Partenaire a la
            responsabilité d’indiquer et de mettre à jour ses horaires
            d’ouverture et les quantités de produits/menu disponibles.
          </p>
          <p className="font-semibold underline mt-2">
            Conformité de la Commande
          </p>
          <p>
            Le Restaurant Partenaire est responsable de la conformité des
            produits livrés à la Commande du Client. En cas de Réclamation, BIP
            BIP est autorisé à :
          </p>
          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li>
              prélever sur le Montant de la Commande le prix du(es) produit(s)
              concerné(s) en vue du remboursement du Client ainsi, le cas
              échéant, que les coûts associés à la récupération du(es)
              produit(s) non-conforme(s)
            </li>
            <li className="list-none font-bold my-1">et</li>
            <li>
              déduire le prix du(es) produit(s) concerné(s) et les coûts
              associés du Montant de la Commande reversé au Restaurant
              Partenaire.
            </li>
          </ul>
        </section>

        <section
          id="assurance"
          className="mb-10 scroll-mt-24"
        >
          <h2>10. ASSURANCE</h2>
          <p>
            Chaque Partie déclare avoir souscrit et maintenir en vigueur, auprès
            d’une compagnie notoirement solvable, une assurance qui garantisse
            les conséquences pécuniaires de la mise en jeu de sa responsabilité
            civile et professionnelle pour les dommages qui pourraient être
            causés à l’autre Partie au cours de l&apos;exécution de l’Accord.
          </p>
        </section>

        <section
          id="ip"
          className="mb-10 scroll-mt-24"
        >
          <h2>11. PROPRIÉTÉ INTELLECTUELLE</h2>
          <p className="mb-2">
            <span className="font-bold">11.1</span> Le Restaurant Partenaire
            octroie à BIP BIP (et ses sociétés affiliées) une licence limitée,
            non-exclusive et non-cessible d’utilisation de ses Marques sur une
            base libre de redevance et pendant la durée de l’Accord pour les
            besoins du référencement du Restaurant Partenaire sur la Plateforme
            et l’exécution des Services.
          </p>
          <p className="mb-2">
            <span className="font-bold">11.2.</span> BIP BIP octroie au
            Restaurant Partenaire une licence limitée, non-exclusive et
            non-cessible d’utilisation de ses Marques sur une base libre de
            redevance et pendant la durée de l’Accord à la seule fin de
            communiquer sur le partenariat entre BIP BIP et le Restaurant
            Partenaire. Toute autre utilisation ou reproduction des Marques de
            BIP BIP devra faire l’objet d’un accord préalable écrit de BIP BIP.
          </p>
          <p className="mb-2">
            <span className="font-bold">11.3</span> Le Restaurant Partenaire
            doit veiller à ne pas créer une confusion dans l’esprit des
            consommateurs sur le rôle de BIP BIP. Le Restaurant Partenaire
            s’interdit toute utilisation 8 des Marques de BIP BIP pouvant
            laisser penser que BIP BIP agit en une autre qualité que celle de
            simple intermédiaire.
          </p>
          <p className="mb-2">
            <span className="font-bold">11.4</span> Les Marques de chaque Partie
            sont et restent la pleine et entière propriété de cette Partie
          </p>
          <p className="mb-2">
            <span className="font-bold">11.5</span> Les autorisations
            mentionnées aux paragraphes précédents ne sauraient conférer à
            l’autre Partie un droit de revendiquer la propriété des Marques ou
            un droit quelconque, notamment de sous- licence, sur celles-ci.
          </p>
          <p className="mb-2">
            <span className="font-bold">11.6</span> En cas de non-respect d’une
            quelconque des obligations citées au présent article, la Partie
            défaillante garantit la Partie lésée pour toutes conséquences de
            quelque nature que ce soit, et ce sans limitation de responsabilité.
          </p>
        </section>

        <section
          id="donnees"
          className="mb-10 scroll-mt-24"
        >
          <h2>12. DONNÉES PERSONNELLES</h2>
          <p className="font-bold">12.1. Règles Générales</p>
          <p>
            Chacune des Parties s’engage à respecter ses obligations respectives
            en vertu de la Réglementation RGPD dans le cadre de la collecte, du
            traitement et de la préservation des Données Personnelles qui
            concernent l’autre Partie.
          </p>
          <p className="font-bold mt-2">
            12.2. Données personnelles relatives aux Clients
          </p>
          <p>
            Le Restaurant Partenaire s’engage à traiter les Données Personnelles
            relatives aux Clients uniquement aux fins de la fourniture des
            produits commandés par lesdits Clients par l’intermédiaire de la
            Plateforme. Le Restaurant Partenaire s’engage à traiter les Données
            Personnelles des Clients qui lui sont confiées par BIP BIP en
            utilisant uniquement le logiciel et les outils fournis par BIP BIP.
          </p>
          <p className="mt-2">Le Restaurant Partenaire s’engage en outre à :</p>
          <ul className="list-disc ml-5 mt-1 space-y-1">
            <li>
              ne réaliser ni ne prendre aucune copie des Données Personnelles
              qui lui sont confiées sans l’accord préalable de BIP BIP
            </li>
            <li>
              ne pas utiliser ou traiter les Données Personnelles à des fins
              autres que celles spécifiées dans l’Accord
            </li>
            <li>
              ne pas divulguer les Données Personnelles à d’autres personnes
            </li>
            <li>
              prendre toutes mesures utiles afin d’assurer la conservation et
              l’intégrité des Données Personnelles et afin d’éviter toute
              utilisation détournée ou frauduleuse des Données Personnelles
            </li>
            <li>
              au terme de l’Accord, pour quelle que cause que ce soit, à
              restituer à BIP BIP l’intégralité des Données Personnelles qui lui
              auront été confiées
            </li>
            <li>
              ne pas conserver de Données Personnelles au-delà de la durée de
              l’Accord
            </li>
          </ul>

          <p className="mt-4 bg-red-50 p-4 rounded-lg text-red-800 border border-red-100">
            Le Restaurant Partenaire devra, à ses propres frais, défendre,
            indemniser et dégager BIP BIP, ses sociétés affiliées, ainsi que
            leurs directeurs, cadres, employés et agents, de toute
            responsabilité concernant (a) toute perte, divulgation non
            autorisée, vol ou compromission de Données Personnelles relatives
            aux Clients en cas de manquement aux obligations du présent article
            et (b) toute violation ou manquement à toute législation relative à
            la protection des données personnelles.
          </p>
        </section>

        <section
          id="resiliation"
          className="mb-10 scroll-mt-24"
        >
          <h2>13. RÉSILIATION</h2>
          <p>
            BIP BIP et le Restaurant Partenaire peuvent résilier l’Accord par
            lettre recommandée avec accusé de réception dans les cas suivants :
          </p>
          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li>
              moyennant le respect d’un préavis de trente (30) jours en cas de
              non-respect par l&apos;autre Partie d&apos;une des obligations
              mises à sa charge par les présentes et après mise en demeure
              restée infructueuse pendant un délai de trente (30) jours,
              nonobstant tous dommages et intérêts auxquels elle pourrait
              prétendre du fait des manquements susvisés
            </li>
            <li>
              immédiatement, en cas de non-respect des obligations visées aux
              articles 11 « Propriété intellectuelle », 12 « Protection des
              données personnelles » et 16 « Confidentialité »
            </li>
            <li>
              en cas d’ouverture d’une procédure de sauvegarde, redressement ou
              liquidation judiciaire de l’autre Partie, sous réserve des
              dispositions d’ordre public applicables
            </li>
            <li>
              en cas de survenance d’un évènement de force majeure conformément
              à l’article 15
            </li>
          </ul>
        </section>

        <section
          id="cession"
          className="mb-10 scroll-mt-24"
        >
          <h2>14. CESSION</h2>
          <p>
            L’Accord ne pourra faire l&apos;objet d&apos;une cession totale ou
            partielle, à titre onéreux ou gracieux par l’une des Parties, sans
            l’accord préalable et écrit de l’autre Partie. Par exception à ce
            qui précède, BIP BIP peut librement céder ou transférer ou tout ou
            partie de ses obligations au titre de l’Accord à toutes sociétés
            affiliées
          </p>
        </section>

        <section
          id="force-majeure"
          className="mb-10 scroll-mt-24"
        >
          <h2>15. FORCE MAJEURE</h2>
          <p>
            La responsabilité de chacune des Parties ne pourra être recherchée
            si l’exécution de ses obligations est retardée ou empêchée en raison
            d’un cas de force majeure, tels que définis par l’article 1218 du
            Code civil. Dans tous les cas, la Partie empêchée devra faire tout
            ce qui est en son pouvoir pour limiter la durée et les effets du cas
            fortuit ou du cas de force majeure.
          </p>
          <p>
            La Partie sujet aux événements de force majeure doit prévenir dans
            un délai de 48 heures l&apos;autre Partie par tous moyens et lui
            donner la nature, les conséquences prévisibles sur la ou les
            obligations affectées, un estimatif de la durée des évènements et de
            son empêchement dans la mesure du possible.
          </p>
          <p>
            Dans l’hypothèse où les effets de la force majeure se prolongeraient
            pendant une durée supérieure à deux (2) mois, les Parties, sur
            l’invitation écrite de la plus diligente d’entre elles, se
            concerteraient pour en tirer les conséquences sur l’exécution de
            l’Accord. A défaut de négociation ou d’accord dans un délai de dix
            (10) jours après expiration de la première période de deux (2) mois,
            chacune des Parties pourra résilier de plein droit et avec effet
            immédiat l’Accord, si bon lui semble, sans devoir aucune indemnité à
            ce titre à l’autre Partie.
          </p>
        </section>

        <section
          id="confidentialite"
          className="mb-10 scroll-mt-24"
        >
          <h2>16. CONFIDENTIALITÉ</h2>
          <p>
            Les Parties s’engagent à n’utiliser les Informations Confidentielles
            que pour les besoins de l’exécution de l’Accord.
          </p>
          <p>
            Les Parties s&apos;engagent pendant toute la durée de l’Accord et
            pendant deux (2) ans à compter sa cessation, pour quelle que cause
            que ce soit, à ce que les Informations Confidentielles :
          </p>
          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li>
              soient protégées et gardées strictement confidentielles, et soient
              traitées avec le même degré de précaution et de protection que la
              Partie Récipiendaire accorde à ses propres Informations
              Confidentielles de même importance
            </li>
            <li>
              ne soient divulguées qu&apos;aux seuls membres de leur personnel,
              représentants ou tiers ayant à en connaître et ne soient pas
              utilisées par ces derniers autrement que dans le but défini par
              l’Accord
            </li>
            <li>
              ne soient utilisées, totalement ou partiellement, dans un but
              autre que celui défini par l’Accord qu’avec le consentement
              préalable et écrit de la Partie Émettrice
            </li>
            <li>
              ne soient ni divulguées ni susceptibles d&apos;être divulguées,
              soit directement, soit indirectement à tout tiers ou à toutes
              personnes autres que celles mentionnées au second alinéa ci-dessus
            </li>
            <li>
              ne soient ni copiées, ni reproduites, ni dupliquées totalement ou
              partiellement lorsque de telles copies, reproductions ou
              duplications n&apos;ont pas été autorisées par la Partie Émettrice
              et ce, de manière préalable, spécifique et par écrit
            </li>
          </ul>

          <p className="mt-2">
            Toutes les Informations Confidentielles et leurs reproductions
            resteront la propriété de la Partie Émettrice et devront être
            restituées à cette dernière immédiatement sur sa demande.
          </p>
          <p>
            Sauf comme prévu ci-dessus, les Parties n&apos;auront aucune
            obligation et ne seront soumises à aucune restriction eu égard à
            toutes Informations Confidentielles dont elles peuvent apporter la
            preuve :
          </p>

          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li>
              qu&apos;elles sont entrées dans le domaine public préalablement à
              leur divulgation ou après celle-ci mais dans ce cas en
              l&apos;absence de toute faute qui soit imputable à la Partie
              Récipiendaire
            </li>
            <li>
              qu&apos;elles sont déjà connues de la Partie Récipiendaire qui
              peut le démontrer par l&apos;existence de documents appropriés
              dans ses dossiers
            </li>
            <li>
              qu&apos;elles ont été reçues d&apos;un tiers de manière licite,
              sans restriction ni violation de l’Accord
            </li>
            <li>
              qu&apos;elles sont le résultat de développements internes
              entrepris de bonne foi par des membres du personnel la Partie
              Récipiendaire n&apos;ayant pas eu accès à ces Informations
              Confidentielles
            </li>
            <li>
              que l&apos;utilisation ou la divulgation ont été autorisées par
              écrit par la Partie Émettrice.
            </li>
          </ul>

          <p className="mt-2">
            Il est expressément convenu entre les Parties que la divulgation par
            les Parties entre elles d&apos;Informations Confidentielles au titre
            de l’Accord ne peut en aucun cas être interprétée comme conférant de
            manière expresse ou implicite à la Partie Récipiendaire un droit
            quelconque. Le droit de propriété sur toutes Informations
            Confidentielles appartient, sous réserve des droits des tiers, en
            tout état de cause à la Partie Émettrice
          </p>

          <p>
            Le terme ou la résiliation de l’Accord n&apos;aura pas pour effet de
            dégager les Parties de leur obligation de respecter les dispositions
            du présent article concernant l&apos;utilisation et la protection
            des Informations Confidentielles reçues avant la date de la
            résiliation ou l&apos;arrivée du terme ; les obligations contenues
            dans ces dispositions restant en vigueur pendant la période définie
            audit article.
          </p>

          <p>
            En cas d&apos;inobservation des obligations ci-dessus décrites, les
            Parties supporteront toutes les conséquences financières résultant
            d&apos;une telle inobservation, sans limitation de responsabilité et
            indépendamment des dommages et intérêts que la Partie lésée se
            réservera le droit de lui réclamer.
          </p>
        </section>

        <section
          id="independance"
          className="mb-10 scroll-mt-24"
        >
          <h2>17. INDÉPENDANCE DES PARTIES</h2>
          <p>
            Les Parties reconnaissent agir chacune pour leur propre compte. Les
            Parties reconnaissent également l’indépendance des Livreurs
            vis-à-vis de BIP BIP.
          </p>
          <p>
            Les Parties ne sont liées par aucun autre engagement que ceux
            explicitement prévus au titre de l’Accord.
          </p>
          <p>
            L’Accord ne crée aucun lien de subordination, mandat, société en
            participation, entreprise commune, relations employeur/employé ou
            franchiseur/franchisé entre les Parties.
          </p>
        </section>

        <section
          id="diverses"
          className="mb-10 scroll-mt-24"
        >
          <h2>18. DISPOSITIONS DIVERSES</h2>
          <p>
            Si une ou plusieurs dispositions de l’Accord sont tenues pour non
            valides ou déclarées comme telles en application d&apos;une loi,
            d&apos;un règlement ou à la suite d&apos;une décision définitive
            d&apos;une juridiction compétente, les autres stipulations garderont
            toute leur force et leur portée.
          </p>
          <p>
            Le fait pour l&apos;une des Parties de ne pas se prévaloir d&apos;un
            manquement par l&apos;autre Partie à l&apos;une quelconque des
            obligations visées dans l’Accord ne saurait être interprété pour
            l&apos;avenir comme une renonciation à l&apos;obligation en cause.
          </p>
        </section>

        <section
          id="loi"
          className="mb-10 scroll-mt-24"
        >
          <h2>19. LOI APPLICABLE</h2>
          <p>L’Accord est expressément soumis à la loi française.</p>
        </section>

        <section
          id="competence"
          className="mb-10 scroll-mt-24"
        >
          <h2>20. ATTRIBUTION DE COMPÉTENCE</h2>
          <p>
            EN CAS DE LITIGE, DE QUELQUE NATURE QUE CE SOIT, ET APRES UNE
            TENTATIVE DE RECHERCHE D’UNE SOLUTION AMIABLE, COMPETENCE EXPRESSE
            EST ATTRIBUEE AU TRIBUNAL DE COMMERCE DE LYON, NONOBSTANT PLURALITE
            DE DEFENDEURS OU APPEL EN GARANTIE, MEME POUR LES PROCEDURES
            D’URGENCE OU LES PROCEDURES CONSERVATOIRES, EN REFERE OU PAR
            REQUETE.
          </p>
        </section>
      </main>
    </div>
  );
};

export default GC;
